export class SubscriptionLevels {
  static Trial: string = 'Trial';
  static Lite: string = 'Lite';
  static Advanced: string = 'Advanced';
  static AIEngineer: string = 'AIEngineer';

  //static parseName(name: string): number | null {
  //  switch (name.toLowerCase()) {
  //    case 'trial':
  //      return SubscriptionLevels.Trial;
  //    case 'lite':
  //      return SubscriptionLevels.Lite;
  //    case 'advanced':
  //      return SubscriptionLevels.Advanced;
  //    default:
  //      return null;
  //  }
  //}
}
